module.exports = __webpack_public_path__ + "img/gys-icon-6.30d42a17.png";